import classes from "./BottomBar.module.css";
import logo from "../../img/BottomBarImg/Logo.png";
import { Link } from "react-router-dom";

function BottomBar() {
  return (
    <div className={classes.bottom_bar}>
      <div className={classes.logo}>
        <img src={logo} alt="Tabufy - שירות המרת נסח טאבו לאקסל" loading="lazy" />
      </div>
      <div className={classes.description}>
        <p>הדרך הקלה להפוך נסחי טאבו לקובץ אקסל ברור ומסודר.</p>
      </div>
      <nav className={classes.nav} aria-label="ניווט תחתון">
        <ul>
          {/* <li>
            <Link to="/contact">צור קשר</Link>
          </li> */}
          <li>
            <Link to="/">דף הבית</Link>
          </li>
          <li>
            <Link to="/faq">שאלות נפוצות</Link>
          </li>
          <li>
            <Link to="/terms">תנאי שימוש</Link>
          </li>
          <li>
            <Link to="/refund-policy">מדיניות ביטולים והחזרים</Link>
          </li>
          <li>
            <Link to="/privacy">מדיניות פרטיות</Link>
          </li>
        </ul>
      </nav>
      <div className={classes.contact}>
        <span>טלפון: <a href="https://wa.me/972505566226" target="_blank" rel="noopener noreferrer">050-5566226</a> | אימייל: <a href="mailto:support@tabu-fy.com">support@tabu-fy.com</a> | כתובת: יעקב דורי, חדרה</span>
      </div>
      <div className={classes.copyright}>
        <p>כל הזכויות שמורות Tabufy 2026 ©</p>
      </div>
    </div>
  );
}

export default BottomBar;
